import { render, staticRenderFns } from "./ProposalInfo.vue?vue&type=template&id=79e3f5d4"
import script from "./ProposalInfo.vue?vue&type=script&lang=js"
export * from "./ProposalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports